import * as yup from "yup";

export const initialValues = {
  value: "",
};

export const validationSchema = yup.object().shape({
  value: yup
    .string()
    .min(3)
    .matches(/^[aA-zZ\s -]+$/, "Invalid input")
    .required(),
});
